import script from "./SalesCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesCategory.vue?vue&type=script&setup=true&lang=js"

import "./SalesCategory.vue?vue&type=style&index=0&id=134ac3a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134ac3a5"]])

export default __exports__